export enum WheelchairIconType {
  dark,
  white
}
